export default __webpack_public_path__ + "static/media/hayq-games.662d99e8.png";